import { render, staticRenderFns } from "./CalendarControls.vue?vue&type=template&id=5fd0679a&scoped=true"
import script from "./CalendarControls.vue?vue&type=script&lang=js"
export * from "./CalendarControls.vue?vue&type=script&lang=js"
import style0 from "./CalendarControls.vue?vue&type=style&index=0&id=5fd0679a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd0679a",
  null
  
)

export default component.exports